import React, { useState,useEffect,Component } from 'react'
import Dashboard from './Dashboard'
import { NotificationManager } from "react-notifications";
import axios from "axios";
import InvalidAccess from "./InvalidAccess";
import { toast } from "react-toastify";


export default function User() {
      if (localStorage.getItem("user") === null) {
    window.location.href = "../";
  }
  const ryts = localStorage.getItem("user_rights");
  const [filtered, setFiltered] = useState("");
  const spltr = "!@$";
  const corp_id = localStorage.getItem("business_id");
  const user_id = localStorage.getItem("user");
  const [ProductItem, setProductItem] = useState([
    {
      id: 0,
      product_name: "",
      manufacture: "",
      sku: "",
      min_price: 0,
      tax: 0,
      qty: 0,
      max_price: 0,
    },
  ]);
  const InitialProductField = [
    {
      id: 0,
      sku: "",
      product_name: "",
      product_id: 0,
      qty: 1,
      min_price: 0,
      tax: 0,
      price: 0,
      pro_description: "",
    },
  ];
  const [ProductField, setProductField] = useState([
    {
      id: 0,
      sku: "",
      product_name: "",
      qty: 1,
      product_id: 0,
      min_price: 0,
      price: 0,
      pro_description: "",

    },
  ]);
const handleFilter = (event)=>{
    const { name, value } = event.target;
    setFiltered(value);
}
  const addNewProduct = (event) => {
    event.preventDefault();
    const newList = ProductField.concat(InitialProductField[0]);
    setProductField(newList);
  };

  const getProduct = {
    corp_id: corp_id,
    module: "grabItems",
    product: "quotationB",
  };

  //start customer controls
  const [cusList, setCustomerList] = useState([
    {
      id: "0",
      company: "",
      name: "",
      user_id: "",
    },
  ]);
  const getCustomer = {
    cusID: 0,
    corp_id: corp_id,
    module: "getCustomer",
    product: "quotationB",
  };
  //end customer controls

  //start user controls
  const userInitial = {
    id: 0,
    name: "",
    email: "",
    password: "",
    corp_id: corp_id,
    user_id: user_id,
    creator_id: user_id,
  };
  const [Currentuser, setCurrentuser] = useState({
    id: 0,
    name: "",
    email: "",
    password: "",
    corp_id: corp_id,
    user_id: user_id,
    creator_id: user_id,
  });

  const [userList, setuserList] = useState([
    {
      id: 0,
      name: "",
      creator_id: user_id,
      user_id: user_id,
    },
  ]);

  const resetForm = () => {
    setCurrentuser(userInitial);
    setProductField(InitialProductField);
  };

  const [getusers, setGetusers] = useState({
    id: 0,
    user_id: user_id,
    corp_id: corp_id,
    module: "getuser",
    product: "quotationB",
  });
  //end user controls
const clear = (event) => {
    const crntfld = event.target.name.split(spltr);
    // ProductField[crntfld[1]].sku=""
    //  event.target.value = "";
  };

  async function Axiosusers(formData) {
    NotificationManager.info("please wait...");
    JSON.stringify(formData);
    axios({
      method: "post",
      url: "./reactManager/",
      data: formData,
    }).then((res) => {
        if (formData.module === "getuser") {
          if (res.data.data != undefined && res.data.data != null) {
            if (formData.id === 0) {
              setuserList(res.data.data);
            } else {
              setCurrentuser({ ...Currentuser, ...res.data.data[0] });
              if (
                res.data.data[0].userItem != undefined &&
                res.data.data[0].userItem != null
              ) {
                setProductField(res.data.data[0].userItem);
              } else {
                setProductField(InitialProductField);
              }
            }
            toast.success("ready to go");
          }else{
            toast.warning("no-data/invalid request");
          }
        }
        if (formData.module === "userM") {
          handleExistingCustomer(res.data);
          toast.info("done!");
        }
      }
    );
  }
  useEffect(() => {
    Axiosusers(getusers);
    
  }, [getusers]);

  
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name.includes("userItem" + spltr)) {
      const crntfld = name.split(spltr);
      console.log(event.nativeEvent.inputType);
      if ( (event.nativeEvent.inputType=="insertReplacementText" || event.nativeEvent.inputType==undefined) &&  crntfld[2] === "sku") {
        const selProdDetail = ProductItem.find((prod) => {
          return prod.sku === value;
        });
        if (selProdDetail !== undefined) {
          const udtProdField = ProductField.map((pros, index) => {
            return index == crntfld[1]
              ? {
                  ...pros,
                  ...selProdDetail,
                  ["price"]: selProdDetail.max_price,
                  ["product_id"]: selProdDetail.id,
                  ["id"]: pros.id,
                  ["sku"]: value,
                }
              : { ...pros };
          });
          console.log(udtProdField);
          setCurrentuser({
            ...Currentuser,
            ["userItem"]: [...udtProdField],
          });
          setProductField(udtProdField);
        }
      } else {
        const udtProdField = ProductField.map((pros, index) => {
          return index == crntfld[1]
            ?  { ...pros, [crntfld[2]]: value }
            : { ...pros }  ;
        });
        
        setCurrentuser({
          ...Currentuser,
          ["userItem"]: [...udtProdField],
        });
        setProductField(udtProdField);
        
      }
    } else {
      setCurrentuser({
        ...Currentuser,
        [name]: value,
      });

    }
  };
  const handleCheckbox = (event) =>{
    const check = (event.target.checked) ? event.target.value : 0;
    const nm = event.target.name;
    setCurrentuser({...Currentuser,[nm]:check})
  }
  const handleInvoiceCheck = (event) =>{
    const check = (event.target.checked) ? 1 : 0;
    setCurrentuser({...Currentuser,['invoiced']:check})
  }
  const handleSubmit = (event) => {
    event.preventDefault();
    if (
      Currentuser.id === 0 ||
      user_id === Currentuser.user_id ||
      user_id === Currentuser.creator_id
    ) {
      const commUdt = Currentuser.comment.replace(/\n/g, "<br />");
      setCurrentuser({ ...Currentuser, ["comment"]: commUdt });
      Axiosusers({ ...Currentuser });
    }
  };
  const generatePDF = (pdfID) => {
    localStorage.setItem("generatePDF", pdfID);
    window.open("../pdfr");
  };
  const handleExistingCustomer = (userId) => {
    setGetusers({ ...getusers, ["id"]: userId });
    Axiosusers(getusers);
  };
  const handlePI = () =>{

  }
  if (
    localStorage.getItem("user") == 20000 ||
    localStorage.getItem("user") == ""
  ) {
    return <InvalidAccess />;
  }
  return (
    <>
      <Dashboard />
      <div id="content_area">
        <div id="list_section">
          <h2>Existing users</h2>
          <h3><form style={{float:'none'}}>
            <input type="text" onChange={handleFilter} placeholder="filter list by name"  value={filtered}  />
          </form></h3>
          <div>
            <ul>
              {userList.filter(function(d){ return d.name.toLowerCase().indexOf(filtered.toLowerCase())!=-1}).map((qt) => {
                return qt.name != "" ? (
                  <li key={qt.id}>
                    <p>{qt.name}<br /><small>(Q.A. NO.: qa{qt.id}</small>)</p>
                    <button onClick={() => handleExistingCustomer(qt.id)}>
                      View
                    </button>
                  </li>
                ) : (
                  ""
                );
              })}
            </ul>
          </div>
        </div>

        <form method="post" onSubmit={handleSubmit}>
          <input type="hidden" value={Currentuser.id} name="id" />
          <input onClick={resetForm} type="reset" value="Add new user" />
          <h2>
            User Manager
          </h2>
          <input
            type="text"
            placeholder="user Name"
            value={Currentuser.name}
            name="name"
            onChange={handleChange}
            required
          />
          <input
            type="email"
            placeholder="Email ID"
            value={Currentuser.email}
            name="email"
            onChange={handleChange}
          />
          <input
            type="password"
            placeholder="password"
            value={Currentuser.password}
            name="password"
            onChange={handleChange}
            required
          />
          <input  type="submit" name="submit" value="Save user" />

        </form>
      </div>
    </>
  );
  }